{
  "lang": "nl",
  "alias": "rijks-rvo",
  "theme": "rijks-ng",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "alignments-mest",
    "bb-xarea",
    "case-template",
    "end-tools",
    "has-no-next-meta",
    "has-required",
    "headings",
    "history",
    "iconset",
    "info-inline",
    "jquery.xarea",
    "logo-switch",
    "md-labels",
    "metadata-change-navtext",
    "metaprogress",
    "model-specific-savecase",
    "model-template",
    "no-login",
    "no-models",
    "no-settings",
    "nonce-metatag",
    "nta:collapsing-grid",
    "nta:contact",
    "nta:dynamic-menu-items",
    "nta:has-no-next",
    "nta:mopinion",
    "nta:path-to-modelname",
    "nta:piwik-nonce",
    "nta:proxymap",
    "nta:rijksoverheidshuisstijlfonts",
    "nta:share",
    "option-filter",
    "questionlabelgroup-ng",
    "savecase-native-dialog",
    "seo-keywords-description",
    "showdown",
    "showdown-converter",
    "tag-too-wide",
    "wrap-table",
    "xsl-to-pdf"
  ],
  "extrainloghtml": "rvo.html, rvoplus.html",
  "arbitrary": {
    "core": {
      "jumplist": {
        "type": "ol"
      }
    },
    "mopinion": {
      "quotumcalculator": {
        "id": "A9YINCK3s0Hr0ZbYzNvgiwyPM11sbZQKwP1O3k41"
      },
      "lkv": {
        "id": "A9YINCK3s0Hr0ZbYzNvgiwyPM11sbZQKwP1O3k41"
      },
      "ce_markering": {
        "id": "hlf4tTOGJkDx2ZNyCES7v1LIfJWNdjCtfM1jDpkQ"
      },
      "regelhulpmest": {
        "id": "TXhkShDsMZdcjgVnWgUse6V9GCXY4pqPtXmEx4bl"
      }
    },
    "seo": {
      "rekenhulplkv": {
        "description": "Met deze calculator van de Rijksoverheid berekent u in maximaal zeven stappen de (op de situatie van de werknemer afgestemde) hoogte van deze financiële tegemoetkomingen voor de komende jaren. Heeft u recht op premiekortingen, het lage-inkomensvoordeel (LIV) of loonkostensubsidie?",
        "keywords": "lage-inkomensvoordeel, premiekorting, premiekortingen, uurloon, werknemer"
      },
      "premiekortingen": {
        "description": "Heeft u recht op premiekortingen of het lage-inkomensvoordeel? Met deze regelhulp van de Rijksoverheid stelt u dit in maximaal zeven stappen vast.",
        "keywords": "participatiewet, wajongeren, WIA-uitkering, doelgroepregister, banenafspraak, lage-inkomensvoordeel, premiekorting, premiekortingen, uurloon, werknemer, doelgroepregister banenafspraak, Wsw, uitkering in dienst"
      },
      "quotumcalculator": {
        "description": "Berekenen hoeveel banen voor mensen uit de doelgroep banenafspraak u moet realiseren om te voldoen aan het quotumpercentage voor de sector overheid",
        "keywords": "Quotumcalculator, Quotumregeling banenafspraak, quotumregeling, quotumpercentage, Rijksoverheid"
      },
      "lkv": {
        "description": "Zoekt u een nieuwe werknemer? Of zoekt u een nieuwe baan? De regelhulp financieel CV helpt u hierbij.",
        "keywords": "Regelhulp financieel CV, financieel cv, aantrekkelijke financiële regelingen, regelingen"
      }
    },
    "path-to-modelname": {
      "notfoundthen": {
        "message": "De regelhulp die u zocht is niet gevonden. Probeert u het op <a href=\"https://www.digitaleoverheid.nl/overzicht-van-alle-onderwerpen/dienstverlening-aan-burgers-en-ondernemers/regelhulpen/\">de startpagina voor regelhulpen</a>."
      }
    },
    "proxymap": {
      "btwprivegebruikauto": {
        "modelname": "btwprivegebruikauto"
      },
      "brandveiligheid": {
        "modelname": "brandveiligheid"
      },
      "mest": {
        "modelname": "regelhulpmest"
      },
      "afval": {
        "modelname": "regelhulpafval",
        "piwik": {
          "code": "6e19eb96-2c4c-4e94-a2e4-25b71fff3078"
        }
      },
      "borgtool": {
        "modelname": "borgtool",
        "piwik": {
          "code": "7f360026-67e4-493b-987b-d9ee47a87d94"
        }
      },
      "dna": {
        "modelname": "dna",
        "piwik": {
          "code": "165aaab3-b29c-4f75-b20d-b1a0934d2e13"
        }
      },
      "quotumcalculator": {
        "modelname": "quotumcalculator",
        "piwik": {
          "code": "7dc67c52-52f3-4fbd-af9c-b3399a8e21f9"
        }
      },
      "financieelcv": {
        "modelname": "lkv",
        "piwik": {
          "code": "4e3b9af0-74d9-4a7f-8820-5c69d868b009"
        }
      },
      "ce_markering": {
        "modelname": "ce_markering",
        "piwik": {
          "code": "4ad3fee5-0a8d-4d2e-bddb-f351385bd597"
        }
      },
      "regelhulpchina": {
        "modelname": "regelhulpchina"
      }
    },
    "piwik": {
      "fallback": {
        "code": "6c6e6ce3-4bf0-4a22-9099-b95d977db66c"
      }
    },
    "end-tools": {
      "block": [
        "email"
      ]
    },
    "history": {
      "keepParams": [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_uid"
      ]
    }
  },
  "template": {
    "logo": "logo-rvo.svg?v=2",
    "companywebsite": "https://www.rvo.nl/",
    "companyname": "Logo: Rijksdienst voor Ondernemend Nederland",
    "logo-alt-text": "Logo Rijksdienst voor Ondernemend Nederland, ga naar de startpagina van RVO.nl",
    "readonly-prop": "disabled"
  },
  "legacy": false
}
